import { Children, ReactNode } from 'react';
import classNames from 'classnames';

import IList from './types';
import useStyles from './styles';

function List({ className, children, gutter }: IList) {
  const classes = useStyles({ gutter });

  return (
    <ul className={classNames(classes.root, className)}>
      {Children.map(children, (child: ReactNode, index: number) => (
        <li className={classes.item} key={index.toString()}>
          {child}
        </li>
      ))}
    </ul>
  );
}

export default List;
